<script lang="ts">
    import type { Price } from '@shared/types/types';

    interface Props {
        price: Price;
        discounted?: boolean;
    }

    let { price, discounted = false }: Props = $props();

    const displayPrice = $derived(`${price.isStartingPrice ? 'ab ' : ''} ${price.retailPrice} €`);
</script>

<span
    class={[
        'oc-headline-50',
        'reptile-price__retailPrice',
        'reptile-price__priceValue',
        discounted && 'reptile-price__priceValue--red',
    ]}
>
    {displayPrice}
</span>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens' as tokens;

    .reptile-price {
        &__retailPrice {
            margin-right: tokens.$oc-semantic-spacing-25;
        }

        &__priceValue {
            white-space: nowrap;

            &--red {
                color: tokens.$oc-semantic-color-text-sale;
            }
        }
    }
</style>
